var render, staticRenderFns
import script from "./DraggableItem.vue?vue&type=script&lang=js&"
export * from "./DraggableItem.vue?vue&type=script&lang=js&"
import style0 from "./DraggableItem.vue?vue&type=style&index=0&id=048862d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048862d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048862d8')) {
      api.createRecord('048862d8', component.options)
    } else {
      api.reload('048862d8', component.options)
    }
    
  }
}
component.options.__file = "src/views/createFlow/build/DraggableItem.vue"
export default component.exports